// extracted by mini-css-extract-plugin
export default {"container":"CategoryFilters__container--2V8xj","resetButton":"CategoryFilters__resetButton--2W4fg"};